import Button from 'ui/atoms/Button/Button';
import Icon from 'ui/atoms/Icon/Icon';
import { CONTENT_TYPES } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React from 'react';
import MaterialPreviewLink from './MaterialPreviewLink';
import MaterialPreviewQuestion from './MaterialPreviewQuestion';
import MaterialPreviewQuiz from './MaterialPreviewQuiz';
import MaterialPreviewVideoLesson from './MaterialPreviewVideoLesson';

function MaterialPreviewViewer({ material, isStudent, t, openResource }) {
  const isOtherType = ![CONTENT_TYPES.LINK, CONTENT_TYPES.TEST, CONTENT_TYPES.QUESTION, CONTENT_TYPES.VIDEOLESSON].includes(material?.content_type_guid);

  return material?.content_type_guid ? (
    <div className="material-preview-viewer__container">
      {material?.content_type_guid === CONTENT_TYPES.LINK && <MaterialPreviewLink material={material} />}
      {material?.content_type_guid === CONTENT_TYPES.TEST && <MaterialPreviewQuiz material={material} />}
      {material?.content_type_guid === CONTENT_TYPES.QUESTION && <MaterialPreviewQuestion material={material} />}
      {material?.content_type_guid === CONTENT_TYPES.VIDEOLESSON && <MaterialPreviewVideoLesson material={material} />}

      {isOtherType && (
        <div className="material-preview-viewer__wrapper">
          <div className="material-preview-viewer">
            <Icon name="xapi" size="4xl" />
          </div>
          {isStudent && (
            <div className="material-preview-viewer__button">
              <Button text={t('lesson:View resource')} variant="primary" onClick={() => openResource(material)} />
            </div>
          )}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
}

MaterialPreviewViewer.propTypes = {
  material: PropTypes.shape({
    content_type_guid: PropTypes.string,
    content_url: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  isStudent: PropTypes.bool,
  t: PropTypes.func.isRequired,
  openResource: PropTypes.func.isRequired,
};

export default MaterialPreviewViewer;
